import React from "react";
import { Row, Col } from "antd";
import { backArrowIcon } from "../../assets/images";
import CustomButton from "../../common/Buttons/CustomButton";
import PersonForm from "./Forms/PersonForm";
import { PersonType } from "../../types/PersonTypes";
import { usePersonFormBackNavigation } from "../../hooks/usePersonFormBackNavigation";
import { defaultSelectedAddress } from "../../types/LocationTypes";
import { getBackPersonFormValues } from "../../helpers/personHelpers";
import { useServiceUserCreationCtx } from "../../context/ServiceUserCreationContext";

function SomeoneElse() {
  const { navigateBack } = usePersonFormBackNavigation();

  const {
    registrationBackBtnClickCtx,
    serviceUserSomeoneElseDetailsCtx,
  } = useServiceUserCreationCtx();
  const [serviceUserSomeoneElseDetails] = serviceUserSomeoneElseDetailsCtx;
  const [isBackBtnClick] = registrationBackBtnClickCtx;

  function getInitialValues() {
    const initialValues = {
      isSameAsHomeAddress: true,
      wandaAccommodations: {
        wheelChairTravel: false,
        wheelChairPresent: false,
        wcToVehicleTransfer: false,
      },
      homeAddress: defaultSelectedAddress,
      mailingAddress: defaultSelectedAddress,
    };

    if (isBackBtnClick) {
      return serviceUserSomeoneElseDetails
        ? getBackPersonFormValues(serviceUserSomeoneElseDetails)
        : initialValues;
    } else {
      return initialValues;
    }
  }

  return (
    <Row>
      <Col xs={2} lg={4} />
      <Col xs={20} lg={16}>
        <CustomButton
          text="Back"
          handlerFunction={navigateBack}
          type="link"
          icon={backArrowIcon}
          className="backBtn"
        />
        <PersonForm
          personType={PersonType.SomeoneElse}
          initialValues={getInitialValues()}
        />
      </Col>
      <Col xs={2} lg={4} />
    </Row>
  );
}

export default SomeoneElse;
